import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import AuthService from "../../services/auth.service";
import UserService from "../../services/user.service";

const user = JSON.parse(localStorage.getItem("user"));

export const signup = createAsyncThunk(
  "auth/user/",
  async ({ first_name, last_name, email, password }, thunkAPI) => {
    try {
      const payload = { first_name, last_name, email, password }
      const response = await AuthService.signup(payload);
      console.log("Signup", response)
      thunkAPI.dispatch(setMessage({message: response.message, status: 'True'}));
      thunkAPI.dispatch(authSlice.actions.getSignupSuccess(response.data))
      return response.data;
    } catch (error) { 
      console.log(error)
      const message =
        // (error.response &&
        //   error.response.data &&
        //   error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message: message, status: error.success}));
      thunkAPI.dispatch(authSlice.actions.hasError(error))
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getProfile = createAsyncThunk(
  "auth/user/",
  async(thunkAPI) => {
    try {
      const response = await UserService.getProfile();
      // console.log('Profile', response[0])
      // authSlice.actions.setUser(response[0])
      return response[0];
    } catch (error) {
      console.log(error)
      return error
    }
  }
)

export const verification = createAsyncThunk(
  "auth/verify/",
  async ({ email, otp }, thunkAPI) => {
    try {
      const payload = { email, otp }
      const response = await AuthService.verification(payload);
      // console.log(response)
      thunkAPI.dispatch(setMessage({message: response.message, status: 'True'}));
      thunkAPI.dispatch(authSlice.actions.setVerificationStatus(response.data))
      return response.data;
    } catch (error) { 
      console.log(error)
      const message =
        // (error.response &&
        //   error.response.data &&
        //   error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message: message, status: error.status || error.success}));
      thunkAPI.dispatch(authSlice.actions.hasError(error))
      return thunkAPI.rejectWithValue();
    }
  }
);

export const resendOtp = createAsyncThunk(
  "auth/re_verify/",
  async ({ email }, thunkAPI) => {
    try {
      const payload = { email }
      const response = await AuthService.resendOtp(payload);
      thunkAPI.dispatch(setMessage(response.data.message));
      return response.data;
    } catch (error) { 
      console.log(error)
      const message =
        // (error.response &&
        //   error.response.data &&
        //   error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message: message, status: error.status || error.success}));
      thunkAPI.dispatch(authSlice.actions.hasError(error))
      return thunkAPI.rejectWithValue();
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgot-password/",
  async ({ email }, thunkAPI) => {
    try {
      const payload = { email }
      const response = await AuthService.forgotPassword(payload);
      thunkAPI.dispatch(setMessage({message: response.message, status: 'True'}));
      return response;
    } catch (error) { 
      console.log(error)
      const message =
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message: message, status: error.status || error.success}));
      thunkAPI.dispatch(authSlice.actions.hasError(error))
      return error
    }
  }
);

export const resetPassword = createAsyncThunk(
  "auth/forgot_password_validate/",
  async ({ email, password, otp }, thunkAPI) => {
    try {
      const payload = { email, password, otp }
      const response = await AuthService.resetPassowrd(payload);
      console.log(response)
      thunkAPI.dispatch(setMessage({message: response.message, status: 'True'}));
      return response;
    } catch (error) { 
      console.log(error)
      const message =
        // (error.response &&
        //   error.response.data &&
        //   error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message: message, status: error.status || error.success}));
      thunkAPI.dispatch(authSlice.actions.hasError(error))
      return thunkAPI.rejectWithValue();
    }
  }
);

export const login = createAsyncThunk(
  "auth/login/",
  async ({ email, password, otp }, thunkAPI) => {
    try {
      const payload = { email, password, otp }
      const response = await AuthService.login(payload);
      // console.log("RESPONSE", response)
      thunkAPI.dispatch(authSlice.actions.setAuthStatus(response.data))
      thunkAPI.dispatch(setMessage({message: response.message, status: 'True'}))
      return response;
    } catch (error) {
        console.log(error)
        const message =
        error.message ||
        error.toString();
        thunkAPI.dispatch(setMessage({message: message, status: 'False' }));
      return error;
      return thunkAPI.rejectWithValue();
    }
  }
);


export const changePinRequest = createAsyncThunk(
  "/pin_update/",
  async (thunkAPI) => {
    try {
      const response = await AuthService.requestPinChange();
      console.log(response)
      return response;
    } catch (error) { 
      console.log(error)
      const message =
        error.message ||
        error.toString();
        return error;
    }
  }
);

export const changePinConfirmation = createAsyncThunk(
  "/pin_update/",
  async (payload, thunkAPI) => {
    try {
      const response = await AuthService.confirmPinChange(payload);
      return response ;
    } catch (error) {
        console.log(error)
        const message =
        error.message ||
        error.toString();
      return error;
    }
  }
);

export const logout = createAsyncThunk(
  "auth/logout", 
  async (_, thunkAPI) => {
    thunkAPI.dispatch(authSlice.actions.signOut())
    return true
  });

  export const sidebarToggle = createAsyncThunk(
    'sidebar-toggle',
    async(_, thunkAPI) => {
      thunkAPI.dispatch(authSlice.actions.toggleSidebar())
      return true
    }
  )

const initialState =
 { 
    isAuthenticated: false, 
    user: null, 
    isLoading: false,
    isOtpVerified: false,
    isAccountCreated: false,
    error: null,
    isManager: false
  };

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    hasError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },
    startLoading(state) {
      state.isLoading = true
    },
    getSignupSuccess(state, action) {
      state.user = action.payload
      state.isAccountCreated = true
      state.isOtpVerified = false
    },
    setVerificationStatus(state, action) {
      state.isOtpVerified = true
      state.isAccountCreated = true
      state.user = action.payload
      state.isLoading = false
      localStorage.setItem('token', action.payload.token)
    },
    setAuthStatus(state, action) {
      state.user = action.payload
      state.isAccountCreated = true
      state.isOtpVerified = true
      state.isAuthenticated = true
      state.isManager = false
      localStorage.setItem('token', action.payload.token)
    },
    setToken(state, action) {
      localStorage.setItem("token", action.payload); 
    },
    signOut(state) {
      state.isAuthenticated = false
      // state.user = null
    },
    setUser(state, action) {
      state.user = action.payload;
    },
    toggleSidebar(state) {
      state.sidebar = ! state.sidebar
    },

  },
  extraReducers: {
    [logout.fulfilled]: (state, action) => {
      state.isAuthenticated = false;
      state.isManager = false;
      localStorage.removeItem('token')
      // state.isAccountCreated = false;
      // state.isOtpVerified = false
    },
    // [login.fulfilled]: (state, action) => {
    //   state.user = action.payload.data
    // },
  },
});

const { reducer } = authSlice;
export default reducer;